import React, { FC } from "react";
import Link from "next/link";

const SimulatorBanner: FC = () => {
  return (
    <Link href="/animefurusato/simulator" passHref>
      <a target="_blank" rel="noreferrer">
        <img src="/image/banner/animefurusato/simulator.png" alt="" width="300" height="63" loading="lazy" />
      </a>
    </Link>
  )
}
export default SimulatorBanner;
